module.exports = __webpack_public_path__ + "assets/d381507f1b8038f4660eb1bd22e51646.svg";